const is_mobile = device.mobile();
let styles = {
    container: {
        background: 'white',
        boxShadow: '0 1px 4px rgba(0,0,0,.15)',
        padding: '2px',
        display: 'flex',
        justifyContent: 'center',
    },
    main_header: {
        // padding:'0px',   
        margin:'10px 0px',
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center',
    },
    title: {
        padding:'5px',
        textAlign:'center',
        fontSize:'16px',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        height:'100%'
    },
    arrow: {
        padding:'5px',
        textAlign:'center',
        fontSize:'16px',
        display:'flex',
        alignItems:'center',
        justifyContent:'start',
        height:'100%'
    },
    row: {
        display: 'flex',
        justifyContent: 'start',
        marginBottom: '10px',
        borderBottom: '1px solid #e0e0e0',
        paddingBottom: '5px',
        gap:'5%',
    },
    row1: {
        display: 'flex',
        justifyContent: 'start',
        marginBottom: '10px',
        borderBottom: '1px solid #e0e0e0',
        paddingBottom: '5px',
        gap:'5%',
        marginTop:'1%',
    },
    item: {
        color:'#7d3cff',
    },
    bold_text: {
        fontWeight: 'bold',
    },
    detailContainer: {
        padding: '1% 2%',
        // backgroundColor: '#f9f9f9',  
        borderRadius: '8px',
    // maxWidth: '600px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection:'column',
    },
    label: {
        fontSize: '12px',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        color: '#8a96a8',
        marginBottom: '4px',
    },
    partnerItem: {
        marginBottom: '5px',
    },
    partnerNumber: {
        marginLeft: '5px',
        color: '#555',
    },
    btn1:{
      background:'#115691',
      borderColor:'#115691',
      color: 'white',
      borderRadius:'6px',
      padding:'6px 14px',
      fontSize:'13px',
      fontWeight:600,
     },

    // Page shell, header and details card
    page: {
      width: '100%',
      padding: is_mobile ? '12px' : '20px 24px',
      background: '#f5f7fb',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '14px',
      background: 'white',
      borderRadius: '12px',
      border: '1px solid #e6e9f0',
      padding: is_mobile ? '14px' : '18px 22px',
      marginBottom: '16px',
    },
    backBtn: {
      width: '36px',
      height: '36px',
      flex: 'none',
      borderRadius: '50%',
      border: '1px solid #cfd8e6',
      background: 'white',
      color: '#115691',
      cursor: 'pointer',
    },
    headerText: {
      flex: 1,
      minWidth: '200px',
    },
    headerTitleRow: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '10px',
    },
    venueName: {
      margin: 0,
      fontSize: is_mobile ? '20px' : '24px',
      fontWeight: 700,
      color: '#1f2d3d',
    },
    headerSub: {
      marginTop: '4px',
      fontSize: '14px',
      color: '#6b7a90',
    },
    statusActive: {
      padding: '3px 10px',
      borderRadius: '999px',
      fontSize: '12px',
      fontWeight: 700,
      color: '#1e7e34',
      background: '#e3f6e8',
    },
    statusInactive: {
      padding: '3px 10px',
      borderRadius: '999px',
      fontSize: '12px',
      fontWeight: 700,
      color: '#b02a37',
      background: '#fbe5e7',
    },
    actions: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
    },
    card: {
      background: 'white',
      borderRadius: '12px',
      border: '1px solid #e6e9f0',
      padding: is_mobile ? '14px' : '20px 22px',
      marginBottom: '16px',
    },
    cardTitle: {
      margin: '0 0 14px 0',
      fontSize: '16px',
      fontWeight: 700,
      color: '#115691',
    },
    detailGrid: {
      display: 'grid',
      gridTemplateColumns: is_mobile ? '1fr' : 'repeat(2, minmax(0, 1fr))',
      gap: '14px 28px',
    },
    detailItem: {
      paddingBottom: '10px',
      borderBottom: '1px solid #eef1f6',
    },
    detailWide: {
      gridColumn: '1 / -1',
    },
    value: {
      fontSize: '14px',
      color: '#1f2d3d',
      lineHeight: 1.5,
    },

}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/centerportal/venueDetails/style.js